import { IconLibrary } from "../icon/IconLibrary";
import { ISelectButton } from "../lists/ISelectButtonList";

export enum SimpleSortBy {
    ASCENDING = "asc",
    DESCENDING = "desc",
    NONE = "none"
}

export interface ISimpleTableRows {
    content: any[];
    controls?: ISelectButton[];
    dragAndDropAction?:(newIndex: number) => void
}

export interface ISimpleTableColumn {
    title: any;
    isToggleButton: boolean;
    onSortAscendingClick?: any;
    onSortDescendingClick?: any;
    defaultSort?: SimpleSortBy
}

export interface ISimpleContent {
    columns: ISimpleTableColumn[];
    rows: ISimpleTableRows[];
}


export interface IDragAndDropRow {
    containerRef: any,
    row: ISimpleTableRows,
    index: number,
    hoverIndex: number | null,
    controlIndex: number | undefined,
    setControlIndex: any,
    moveRow: any,
    rowContentLength: number,
    setHoverIndex: any,
    openMenu: boolean,
    setOpenMenu: any,
    dragAndDropAction?:(newIndex: number) => void,
    isPaginated?: boolean,
    paginationInformation?: {
        totalPages?: number,
        currentPage?: number,
        resultsPerPage?: number
        totalItems?: number;
    }
}


export interface IDragAndDropRow {
    containerRef: any,
    row: ISimpleTableRows,
    index: number,
    hoverIndex: number | null,
    controlIndex: number | undefined,
    setControlIndex: any,
    moveRow: any,
    rowContentLength: number,
    setHoverIndex: any,
    openMenu: boolean,
    setOpenMenu: any,
    dragAndDropAction?:(newIndex: number) => void,
    isPaginated?: boolean,
    paginationInformation?:{
        totalPages?: number,
        currentPage?: number,
        resultsPerPage?: number
        totalItems?: number;
    }
}

export interface ISimpleTableMenu { 
    isControlIndex : boolean, 
    setControlIndex : ()=>void, 
    buttons?: ISelectButton[]
}

export interface ISimpleTableColumn {
    title: any;
    isToggleButton: boolean;
    onSortAscendingClick?: any;
    onSortDescendingClick?: any;
    defaultSort?: SimpleSortBy
}

export interface ISimpleTableRows {
    content: any[];
    controls?: ISelectButton[];
    dragAndDropAction?:(newIndex: number) => void
}

export interface IDragAndDropControls {
    className?: string, 
    iconName: IconLibrary, 
    text: string, 
    color?: string
}

export interface ISimpleTableContent {
    columns: ISimpleTableColumn[];
    rows: ISimpleTableRows[];
}

export interface ISimpleTableProps {
    simpleTableContent: ISimpleTableContent;
    noDataMessage?: string;
    maxContentLength?: number;
    isInfiniteScroll: boolean;
    getMoreContent?: () => void;
    infiniteScrollFetchCondition?: boolean,
    isDragAndDrop?: boolean;
    onDragAndDrop?: (item:any, oldpos: number, newPos: number) => void
    isPaginated?: boolean // non-infinite scrooll pagination
    paginationInformation?: {
        currentPage?: number
        totalPages?:number
        resultsPerPage?:number
        totalItems?: number
    };
    isLoading: boolean
    gettingMore?: boolean,
    hideActionsColumn?: boolean
}

export interface ISimpleRow {
    rowIndex: number;
    setControlIndex: any;
    row: ISimpleTableRows;
    isControlIndex: boolean;
    hasControlsColumn?: boolean
}

export interface IDragRow extends ISimpleRow{
    rowIndex: number;
    setHoverIndex: any;
    hoverIndex?: number;
    moveRow: any;
    controlIndex?: number;
    maxRows: number;
}

export interface ISimpleProps {
    simpleTableContent: ISimpleContent;
    noDataMessage?: string;
    maxContentLength?: number;
    isInfiniteScroll: boolean;
    getMoreContent?: () => void;
    infiniteScrollFetchCondition?: boolean,
    isDragAndDrop?: boolean;
    onDragAndDrop?: (item:any, oldpos: number, newPos: number) => void
    isPaginated?: boolean;
    paginationInformation?: {
        currentPage?: number
        totalPages?:number
        resultsPerPage?:number
        totalItems?: number
    };
    isLoading: boolean
    gettingMore?: boolean
}

export interface ISimpleRow {
    rowIndex: number;
    setControlIndex: any;
    row: ISimpleTableRows;
    isControlIndex: boolean;
    hasControlsColumn?: boolean
}

export interface IDragRow extends ISimpleRow {
    rowIndex: number;
    setHoverIndex: any;
    hoverIndex?: number;
    moveRow: any;
    controlIndex?: number;
    maxRows: number;
}

export interface IUseDragAndDropControlsProps {
    index: number;
    rowContentLength: number;
    paginationInformation?:{
        totalPages?: number,
        currentPage?: number,
        resultsPerPage?: number
        totalItems?: number;
    }
    isPaginated?: boolean;
    handleButtonMove: (index: number, newIndex: number, isNewPageMove?: boolean) => void;
}
